var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":_setup.currentSrc,"alt":"foto de perfil","width":_vm.size,"height":_vm.size},on:{"error":_setup.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }